import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { Time, formatDate } from '@angular/common';
import { DoctorsModel } from 'src/app/models/DoctorsModel';
import { DoctorsService } from 'src/app/services/DoctorsService';
import { RoomsModel } from 'src/app/models/RoomsModel';
import { RoomsService } from 'src/app/services/RoomsService';
import { LocalStorageService } from 'ngx-webstorage';
import { MatDialog } from '@angular/material/dialog';
//import { PopuppatientsearchComponent } from '../popuppatientsearch/popuppatientsearch.component';
import { PatientModel } from 'src/app/models/PatientsModel';
import { ReservationModel } from 'src/app/models/ReservationModel';
import { ReservationService } from 'src/app/services/ReservationService';
//import { ReportFromToComponent } from '../report-from-to/report-from-to.component';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
//import { DoctorssearchComponent } from '../doctorssearch/DoctorssearchComponent';
import { DataBankService } from 'src/app/services/DataBankService';
import { DatabankModel } from 'src/app/models/DataBankModel';
import { ReservationVModel } from 'src/app/models/ReservationVModel';
//import { PreparationOrderComponent } from '../preparation-order/preparation-order.Component';
import { interval } from 'rxjs';
import { DoctorssearchComponent } from '../doctorssearch/doctorssearch.component';
import { ReportFromToComponent } from '../report-from-to/report-from-to.component';
import { ProgStepsComponent } from '../prog-steps/prog-steps.component';

@Component({
  selector: 'app-reservationengine',
  templateUrl: './reservationengine.component.html',
  styleUrls: ['./reservationengine.component.css']
})
export class ReservationengineComponent implements OnInit {
  ReportURL0 = 'CocReports/ReservationByRoom';
  ReportURL1 = 'CocReports/ReservationByDoctor';
  ReportURL2 = 'CocReports/ReservationByPatient';

  docCode = '';
  docName = '';
  compCode = '1';
  userID = 'sa';
  ///---------- decliration of Patients ----------
  patientCode = '';
  patientFName = '';
  diagnosis = '';
  patientLName = '';
  patientFullName = '';
  modifaiedDate =   formatDate(new Date(), 'yyyy-MM-dd', 'en');
  //resid = 0;
  //---------------------Reservation Decliration-------------------------------
  patientName = '';
  resDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');

  resTime = formatDate(new Date(), 'HH:mm', 'en');
  resToTime = formatDate(new Date(), 'HH:mm', 'en');

  resDuration = '';
  resRoom = '1';
  resRoomDesc = '1';
  resDoc = '';
  resDocName = '';
  resType = '';
  resNotes = '';
  resStatus = '';
  roomCode = '';
  roomName = '';
  resPhone = '';
  resDate1 = '';
  id = 0;

  PatientCode ='';
  roomType = '';

  fromDate='';
  toDate='';
  fromDateD = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  toDateD = formatDate(new Date(), 'yyyy-MM-dd', 'en');

  wk_FromTime =formatDate(new Date(), 'HH:mm:ss', 'en');
  wk_ToTime = formatDate(new Date(), 'HH:mm:ss', 'en');

  screenTitle ='';
  styleColor =[];
  stylebackColor =[];
  roomsList: RoomsModel[] = [];
  doctorsList: DoctorsModel[] = [];

  reservationList: ReservationVModel[] = [];
  tsduration =0;
  @Output() submitClicked = new EventEmitter<any>();
  attendtime  =formatDate(new Date(), 'HH:mm', 'en');


  constructor(
    public doctorsService: DoctorsService,
    public roomsService: RoomsService,
    public storage: LocalStorageService,
    public patientsSelectedData: PatientModel,
    private dialogref: MatDialog,
    public resevationService: ReservationService,
    public reservation: ReservationVModel,

    public reservationSelectedData: ReservationModel,
    public DoctorsService : DoctorsService,
    public doctorSelectedData : DoctorsModel,
    public dataBankService : DataBankService,
    public route: Router,

  ) { }

  ngOnInit(): void {
   /// interval(50000).subscribe(() => {this.refreshView();});

    this.retriveRoomsLookupTop();
    this.RetriveDoctorTop();
    this.docCode= this.storage.retrieve('stgEmpId')
    this.roomType = '';
    this.resStatus ='';
    this.retriveRes();
   

  }
refreshView() {
       this.ngOnInit(); // Call ngOnInit to reinitialize the component
  }
  ///-------------- retrive reservation table -----------------
  retriveRes() {
    this.reservationList = [];
    this.resevationService.getDaileyReservation(this.resDate,this.roomType,this.roomCode, this.docCode,this.resType,this.resStatus, this.storage.retrieve('stgcompCode')).subscribe((data: ReservationVModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.stylebackColor[i] = 'black';
          this.styleColor[i] = 'black';
          this.reservationList[i] = data[i];
          this.reservationList[i].resstatus = data[i].resstatus
          this.reservationList[i].restime =  formatDate(data[i].restime, 'h:mm a', 'en') ;
          this.reservationList[i].restotime =  formatDate(data[i].restotime, 'h:mm a', 'en') ;
          if(data[i].resstatus == '' || data[i].resstatus == null){this.reservationList[i].resstatus = 'Reservation'}
          if(data[i].resstatus == 'Now' )
            {this.stylebackColor[i] = 'red';this.styleColor[i] = 'white'}
          if(data[i].resstatus == 'Attend')
            {
              this.reservationList[i].resstatus = data[i].resstatus;
              this.stylebackColor[i] = 'green'; this.styleColor[i] = 'white'};
            }
      });

    }

  ///------------------ Look ups ------------------------------

  retriveRoomsLookupTop() {
    this.roomsService.getRoomsLookupTop(this.compCode).subscribe((data: RoomsModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.roomsList[i] = data[i];
        }
      });
  }
  openDoctorDialog(){
    const dialogRef = this.dialogref.open(DoctorssearchComponent,
      {
        data: {
          dataKey: this.doctorSelectedData,
          type : ''
        }
      });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {
        this.docCode = result.docCode;
        this.docName = result.docName;

        this.RetriveDoctor();
        dialogSubmitSubscription.unsubscribe();
      });
  }
  RetriveDoctor(){
    this.DoctorsService.getdoctors(this.docCode,this.storage.retrieve('stgcompCode')).subscribe((data: DoctorsModel) => {
      this.docName = data.docName;

    }
    );
  }
  RetriveDoctorTop(){
    this.doctorsList = [];
    this.DoctorsService.getDoctorsLookupTop(this.storage.retrieve('stgcompCode')).subscribe((data: DoctorsModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.doctorsList[i] = data[i];
      }
    }
    );
  }

  ///------------- Open Preparation Order ------------------
  OpenPreparation(res : ReservationVModel) {
    this.storage.store('stgPatientCode',res.patientcode);
    this.storage.store('stgDoctorCode',res.resdoc);
    this.storage.store('stgDocumentNumber',res.docnumber);
    this.storage.store('stgDocumentDate',res.resdate);
  }

  Chang_Status(res : ReservationVModel){
      this.attendtime  =formatDate(new Date(), 'HH:mm', 'en');
      const str1 = formatDate(this.modifaiedDate, 'yyyy-MM-dd', 'en') + 'T' + this.attendtime+':00.000Z';

      this.reservationSelectedData.resStatus = res.resstatus;
      this.reservationSelectedData.id = res.id;
      this.reservationSelectedData.modifiedDate = str1;
      this.resevationService.UpdateRese(this.reservationSelectedData).subscribe(
        (data) => {

        },
        (error) => {
          alert(error);
        }
      );
      this.retriveRes()
  }

  ProgStep(res : ReservationVModel){
    this.storage.store('stgPatientCode',res.patientcode);
    this.storage.store('stgDoctorCode',res.resdoc);
    this.storage.store('stgDocumentNumber',res.docnumber);
    this.storage.store('stgDocumentDate',res.resdate);

    const dialogRef = this.dialogref.open(ProgStepsComponent,
        {
          data: {
            dataKey: this.reservationSelectedData,
            patientid : res.patientcode,
            patientname : res.patientname,
            patdate : this.resDate,
            visittype : res.restype,
            id : res.id,
            attendtime : res.modifiedDate,
          },
          width: '47%',
        //  height: '42vw',
        });
      dialogRef.afterClosed().subscribe(result => {
      });

      const dialogSubmitSubscription =
        dialogRef.componentInstance.submitClicked.subscribe(result => {
          this.docCode = result.docCode;
          this.docName = result.docName;

          this.RetriveDoctor();
          dialogSubmitSubscription.unsubscribe();
        });
    }
  //-------------- end patient searching -------------------
  NewData() {
    this.resDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.resTime = formatDate(new Date(), 'HH:mm', 'en');
    this.resToTime = formatDate(new Date(), 'HH:mm', 'en');

    this.patientCode = '';
    this.patientName = '';
    this.patientFName = '';
    this.resDoc = '';
    this.docCode = '';
    this.docName = '';
    this.resDocName = '';
    this.resType = '';
    this.resNotes = '';
    this.resStatus = '';
    this.resPhone = '';
    this.compCode = '1';
    this.userID = '';
    this.modifaiedDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.id = 0;
    this.retriveRes();
  }
  startTimer(interval: number) {
    setInterval(() => {
      window.location.reload();
    }, interval * 1000); // Convert interval to milliseconds
  }
  mesgDelete() {

    if (this.storage.retrieve('wk_Staff_Read') == true)
    this.MesgAuthorization();
else {
    Swal({
      title: 'Are you sure?',
      text: 'You will not be able to recover this record!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then(
      () => {
        this.delReservation_Line();
        Swal('Deleted!', 'Your record has been deleted.', 'success');
      },
      function (dismiss) {
        if (dismiss === 'cancel') {
          Swal('Cancelled', 'Your record is safe :)', 'error');
        }
      }
    );
}
  }

  delReservation_Line() {
    console.log("ID:",this.id)
    this.resevationService
      .delReservation_Line_1(
        this.id,
        this.storage.retrieve('stgcompCode')
      )
      .subscribe((data: ReservationModel) => {
        this.patientCode = data.patientCode;
        this.patientName = data.patientName;
        this.resDoc = data.resDoc;
        this.resDocName = data.resDocName;
        this.compCode = data.compCode;
        this.userID = data.userID;
        this.resPhone = data.resPhone;
        this.modifaiedDate = data.modifiedDate;
        this.NewData();
        this.retriveRes();

        this.resTime = formatDate(new Date(), 'HH:mm', 'en');
        this.resToTime = formatDate(new Date(), 'HH:mm', 'en');
      });
  }


  SelectReservation(res: ReservationVModel) {
    this.reservationSelectedData.resRoom = res.resroom;
    this.reservationSelectedData.resRoomDesc = res.roomname;
    this.reservationSelectedData.resDate = res.resdate;

    this.reservationSelectedData.resTime = res.restime;
    this.reservationSelectedData.resToTime = res.restotime;

    this.patientCode = res.patientcode;
    this.patientFName = res.patientname;
    this.docCode = res.resdoc;
    this.reservationSelectedData.resRoomDesc = res.docname;
    this.RetriveDoctor();
    this.resTime   =  res.restime  ;
    this.resToTime = res.restotime ;

    this.resType = res.restype;
    this.resNotes = res.resnotes;
    this.resStatus = res.resstatus;
    this.resPhone = res.resphone;
    this.id = res.id;

    this.submitClicked.emit(this.reservationSelectedData);


  }

  ReportReservation() {
    this.route.navigate(['report-vewier', this.ReportURL0]);
  }
  ReportReservationD() {
    this.route.navigate(['report-vewier', this.ReportURL1]);
  }
  ReportReservationP() {
    this.route.navigate(['report-vewier', this.ReportURL2]);
  }

  mesgSave() {
    Swal({
      title: 'Your work has been saved',
      type: 'success',
      showConfirmButton: false,

      timer: 1500,
    });
  }
  MesgAuthorization() {
    Swal({
      type: 'warning',
      title: 'Oops...',
      text: 'Sorry .... You are not authorized !!',
      showConfirmButton: false,
      timer: 2000,
    });
  }

  openDialog_1(){
    this.screenTitle ='Reservation by doctor from date to date';
    const dialogRef = this.dialogref.open(ReportFromToComponent,
      {
        data:
          {dialogTitle: this.screenTitle, dialogText: 'Year_N-Date_Y-Pat_N-Doc_Y-Butt_Y-Room_N'}
      });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {

        this.fromDate = result.docName;
        this.toDate = result.docTitle;
        this.fromDateD = result.docWMMobile;
        this.toDateD = result.docWmail;
        this.docCode = result.docCode;

        dialogSubmitSubscription.unsubscribe();
        this.storage.store('stgParD1', this.fromDateD);
        this.storage.store('stgParD2', this.toDateD);
        this.storage.store('stgParD3', this.docCode);



        this.route.navigate(['report-vewier', this.ReportURL1]);

      });
  }

  openDialog_2(){
    this.screenTitle ='Reservation by treatment room from date to date';
    const dialogRef = this.dialogref.open(ReportFromToComponent,
      {
        data:
          {dialogTitle: this.screenTitle, dialogText: 'Year_N-Date_Y-Pat_N-Doc_N-Butt_Y-Room_Y'}
      });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {

        this.fromDate = result.docName;
        this.toDate = result.docTitle;
        this.fromDateD = result.docWMMobile;
        this.toDateD = result.docWmail;
        this.roomCode = result.docDepartment;

        dialogSubmitSubscription.unsubscribe();
        this.storage.store('stgParD1', this.fromDateD);
        this.storage.store('stgParD2', this.toDateD);
        this.storage.store('stgParD3', this.roomCode);



        this.route.navigate(['report-vewier', this.ReportURL0]);

      });
  }

  openDialog_3(){
    this.screenTitle ='Reservation by patient from date to date';
    const dialogRef = this.dialogref.open(ReportFromToComponent,
      {
        data:
          {dialogTitle: this.screenTitle, dialogText: 'Year_N-Date_Y-Pat_Y-Doc_N-Butt_N-Room_N'}
      });
    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {

        this.fromDate = result.patientFName ;
        this.toDate = result.birthDate;
        this.fromDateD = result.telHome;
        this.toDateD = result.patientFullName;
        this.PatientCode = result.patientCode;

        dialogSubmitSubscription.unsubscribe();
        this.storage.store('stgParD1', this.fromDateD);
        this.storage.store('stgParD2', this.toDateD);
        this.storage.store('stgParD3', this.PatientCode);



        this.route.navigate(['report-vewier', this.ReportURL2]);

      });
  }

}
